import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Dashboard from "./Dashboard";
import ContentLoader from "../../Loader/ContentLoader";

export default function DashboardLayout() {
  return (
    <Dashboard>
      <Suspense fallback={<ContentLoader />}>
        <Outlet />
      </Suspense>
    </Dashboard>
  );
}
